/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  var MONOGRAM_VARIANT_ID = 50250354393389;

  /**
   * Fetch full cart from /cart.js (includes item properties).
   */
  function fetchCart() {
    var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart';
    var url = cartUrl.replace(/\/cart\/?$/, '/cart.js');
    return fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        return res.json();
      })
      .catch(function () {
        return null;
      });
  }

  /**
   * Update a cart line quantity (or remove if quantity 0).
   */
  function changeCartLine(key, quantity) {
    var url = (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart';
    url = url.replace(/\/cart\/?$/, '/cart/change.js');
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    }).then(function (r) {
      return r.json();
    });
  }

  /**
   * Rebuild cart drawer from section HTML, same as Broadcast after add-to-cart (theme.dev.js getCart on CartDrawer).
   */
  function refreshCartFromTheme() {
    if (window.cart && typeof window.cart.getCart === 'function') {
      window.cart.getCart();
    } else {
      if (window.cart && typeof window.cart.getCartItemCount === 'function') {
        var el = document.querySelector('[data-cart-count]');
        if (el) el.textContent = String(window.cart.getCartItemCount());
      }
    }
  }

  /**
   * Add variant to cart. Optional: properties, selling_plan (re-add after monogram removal).
   */
  function addToCart(variantId, quantity, options) {
    options = options || {};
    var payload = { id: variantId, quantity: quantity };
    if (options.properties && typeof options.properties === 'object') {
      var pk = Object.keys(options.properties);
      if (pk.length > 0) payload.properties = options.properties;
    }
    if (options.selling_plan != null && options.selling_plan !== '') {
      payload.selling_plan = options.selling_plan;
    }
    var url =
      (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add';
    url = url.replace(/\/cart\/add\/?$/, '/cart/add.js');
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (r) {
      return r.json();
    });
  }

  function isMonogramPropertyKey(key) {
    if (!key || typeof key !== 'string') return false;
    if (key === '_main_monogram') return true;
    if (key.indexOf('Monogram') === 0) return true;
    if (key.indexOf('Mongram') === 0) return true;
    return false;
  }

  function getNonMonogramProperties(item) {
    var props = (item && item.properties) || {};
    var out = {};
    for (var k in props) {
      if (!Object.prototype.hasOwnProperty.call(props, k)) continue;
      if (isMonogramPropertyKey(k)) continue;
      var v = props[k];
      if (v == null) continue;
      if (typeof v === 'string' && v.trim() === '') continue;
      out[k] = v;
    }
    return out;
  }

  var monoPageRestore = null;

  function setCartUIProcessing(isOn) {
    var drawer = document.getElementById('cart-drawer');
    if (drawer) drawer.classList.toggle('is-loading-cart', isOn);
    var page = document.querySelector('[data-cart-page]');
    if (page) page.classList.toggle('is-loading-cart', isOn);
  }

  function escapeDataItemSelector(lineKey) {
    return String(lineKey).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  /**
   * Match Broadcast updateCart: cart gets .is-loading, disableCartButtons, line row .is-loading.
   * If [data-cart-page] is not the same node as the theme’s cart (drawer in DOM + full cart), disable that form too.
   */
  function setThemeMonogramRemovalLoading(isOn, lineKey) {
    var api = window.cart;
    var lineEl = null;
    if (lineKey) {
      try {
        lineEl = document.querySelector(
          '.cart__item[data-item="' + escapeDataItemSelector(lineKey) + '"]'
        );
      } catch (e) {
        lineEl = null;
      }
    }
    if (isOn) {
      if (api) {
        if (api.cart) api.cart.classList.add('is-loading');
        if (typeof api.disableCartButtons === 'function') api.disableCartButtons();
      }
      var page = document.querySelector('[data-cart-page]');
      var cartNode = api && api.cart;
      if (page && cartNode && page !== cartNode) {
        page.classList.add('is-loading');
        monoPageRestore = [];
        page.querySelectorAll('input').forEach(function (el) {
          monoPageRestore.push({
            t: 'in',
            el: el,
            w: el.disabled,
            hadClass: el.classList.contains('is-disabled'),
          });
          el.classList.add('is-disabled');
          el.disabled = true;
          try {
            el.blur();
          } catch (e) {}
        });
        page
          .querySelectorAll(
            'button, [data-item-remove], a.cart__item__remove, button.cart__checkout, a.cart__checkout'
          )
          .forEach(function (el) {
            if (el.tagName === 'A') {
              monoPageRestore.push({
                t: 'a',
                el: el,
                pe: el.style.pointerEvents,
                tab: el.getAttribute('tabindex'),
              });
              el.setAttribute('tabindex', '-1');
              el.style.pointerEvents = 'none';
            } else {
              monoPageRestore.push({
                t: 'btn',
                el: el,
                w: el.disabled,
                had: el.hasAttribute('disabled'),
              });
              el.setAttribute('disabled', 'disabled');
              el.disabled = true;
            }
          });
      }
      if (lineEl) lineEl.classList.add('is-loading');
    } else {
      if (lineEl) lineEl.classList.remove('is-loading');
      document.querySelectorAll('.cart__item.is-loading').forEach(function (el) {
        el.classList.remove('is-loading');
      });
      if (api && typeof api.enableCartButtons === 'function') {
        api.enableCartButtons();
      } else if (api && api.cart) {
        api.cart.classList.remove('is-loading');
      }
      if (monoPageRestore && monoPageRestore.length) {
        monoPageRestore.forEach(function (o) {
          if (!o || !o.el) return;
          if (o.t === 'a') {
            o.el.style.pointerEvents = o.pe || '';
            if (o.tab == null) o.el.removeAttribute('tabindex');
            else o.el.setAttribute('tabindex', o.tab);
          } else if (o.t === 'in') {
            o.el.disabled = o.w;
            if (!o.hadClass) o.el.classList.remove('is-disabled');
          } else {
            o.el.disabled = o.w;
            if (!o.had) o.el.removeAttribute('disabled');
          }
        });
        monoPageRestore = null;
      }
      var page2 = document.querySelector('[data-cart-page]');
      if (page2) page2.classList.remove('is-loading');
    }
  }

  function removeMonogramFromLineItem(lineKey) {
    return fetchCart().then(function (cart) {
      if (!cart || !cart.items) {
        return Promise.resolve({ ok: false, reason: 'no_cart' });
      }
      var item;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].key === lineKey) {
          item = cart.items[i];
          break;
        }
      }
      if (!item || !isMainMonogramItem(item)) {
        return Promise.resolve({ ok: false, reason: 'not_monogram' });
      }
      var vid = item.variant_id;
      var qty = typeof item.quantity === 'number' ? item.quantity : 1;
      var kept = getNonMonogramProperties(item);
      var plan =
        item.selling_plan_allocation &&
        item.selling_plan_allocation.selling_plan &&
        item.selling_plan_allocation.selling_plan.id != null
          ? item.selling_plan_allocation.selling_plan.id
          : null;
      return changeCartLine(lineKey, 0)
        .then(function () {
          return addToCart(vid, qty, { properties: kept, selling_plan: plan });
        })
        .then(function () {
          return fetchCart();
        })
        .then(function (latestCart) {
          return syncMonogramCount({ skipAfterCartSync: true, cart: latestCart });
        })
        .then(function () {
          monoPageRestore = null;
          afterCartSync();
          return { ok: true };
        });
    });
  }

  function initRemoveMonogramFromCart() {
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('[data-remove-monogram]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      if (btn.disabled) return;
      var key = btn.getAttribute('data-line-key');
      if (!key) return;
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      setThemeMonogramRemovalLoading(true, key);
      removeMonogramFromLineItem(key)
        .then(function (result) {
          var ok = result && result.ok;
          if (!ok) {
            setThemeMonogramRemovalLoading(false, key);
            btn.removeAttribute('aria-busy');
            btn.disabled = false;
            return;
          }
        })
        .catch(function () {
          setThemeMonogramRemovalLoading(false, key);
          btn.removeAttribute('aria-busy');
          btn.disabled = false;
          window.location.reload();
        });
    });
  }

  /**
   * True if this cart line is a main monogram product (added with #monogramOptions in the form).
   * Main monogram = has _main_monogram or legacy Monogram Name / Monogram Font Style. Not the monogram add-on variant.
   */
  function isMainMonogramItem(item) {
    if (!item || item.variant_id === MONOGRAM_VARIANT_ID) return false;
    var props = item.properties || {};
    for (var k in props) {
      if (!Object.prototype.hasOwnProperty.call(props, k)) continue;
      var v = props[k];
      if (v == null) continue;
      if (String(v).trim() === '') continue;
      if (k === '_main_monogram') return true;
      if (k.indexOf('Monogram') === 0 || k.indexOf('Mongram') === 0) return true;
    }
    return false;
  }

  /**
   * Count main monogram products (total quantity of lines that are main monogram).
   * Monogram product count in cart should always equal this.
   */
  function getMainMonogramCount(items) {
    if (!items || !items.length) return 0;
    var count = 0;
    for (var i = 0; i < items.length; i++) {
      if (isMainMonogramItem(items[i])) {
        count += typeof items[i].quantity === 'number' ? items[i].quantity : 1;
      }
    }
    return count;
  }

  /**
   * Get total quantity of monogram add-on variant and the line keys.
   */
  function getMonogramLines(items) {
    if (!items || !items.length) return { totalQty: 0, lines: [] };
    var lines = [];
    var totalQty = 0;
    for (var i = 0; i < items.length; i++) {
      if (items[i].variant_id === MONOGRAM_VARIANT_ID) {
        var qty = typeof items[i].quantity === 'number' ? items[i].quantity : 1;
        totalQty += qty;
        lines.push({ key: items[i].key, quantity: qty });
      }
    }
    return { totalQty: totalQty, lines: lines };
  }

  /**
   * Sync monogram add-on quantity to match main monogram product count.
   * Three types: (1) monogram product = add-on variant; (2) main monogram product = added with #monogramOptions; (3) non-monogram product.
   * Rule: monogram product count must equal total quantity of main monogram products. Only sync when main monogram changes; non-monogram updates do nothing.
   */
  function afterCartSyncIfNeeded(options) {
    if (options && options.skipAfterCartSync) return;
    afterCartSync();
  }

  function syncMonogramCount(options) {
    function runWithCart(cart) {
      if (!cart || !cart.items || !cart.items.length) return Promise.resolve();
      var items = cart.items;
      var mainMonogramCount = getMainMonogramCount(items);
      var monogram = getMonogramLines(items);

      if (mainMonogramCount === 0) {
        if (monogram.lines.length === 0) return Promise.resolve();
        var removePromises = monogram.lines.map(function (line) {
          return changeCartLine(line.key, 0);
        });
        return Promise.all(removePromises).then(function () {
          afterCartSyncIfNeeded(options);
        });
      }

      if (monogram.totalQty < mainMonogramCount) {
        if (monogram.lines.length > 0) {
          var promises = [];
          promises.push(changeCartLine(monogram.lines[0].key, mainMonogramCount));
          for (var j = 1; j < monogram.lines.length; j++) {
            promises.push(changeCartLine(monogram.lines[j].key, 0));
          }
          return Promise.all(promises).then(function () {
            afterCartSyncIfNeeded(options);
          });
        }
        var toAdd = mainMonogramCount - monogram.totalQty;
        return addToCart(MONOGRAM_VARIANT_ID, toAdd)
          .then(function () {
            afterCartSyncIfNeeded(options);
          })
          .catch(function () {});
      }

      if (monogram.totalQty > mainMonogramCount) {
        var targetQty = mainMonogramCount;
        var promises = [];
        var remaining = targetQty;
        for (var i = 0; i < monogram.lines.length; i++) {
          var newQty =
            remaining <= 0
              ? 0
              : i === monogram.lines.length - 1
                ? remaining
                : Math.min(monogram.lines[i].quantity, remaining);
          promises.push(changeCartLine(monogram.lines[i].key, newQty));
          remaining -= newQty;
        }
        return Promise.all(promises).then(function () {
          afterCartSyncIfNeeded(options);
        });
      }

      return Promise.resolve();
    }
    if (options && options.cart) {
      return runWithCart(options.cart).catch(function () {});
    }
    return fetchCart()
      .then(function (cart) {
        return runWithCart(cart);
      })
      .catch(function () {});
  }

  /**
   * After cart changes: on /cart, reload so the main cart (data-cart-page) updates — CartDrawer's
   * getCart() only replaces the first [data-items-holder] in the DOM (usually the drawer), not the page form.
   * Else: theme getCart() for the drawer.
   */
  function afterCartSync() {
    var p = (window.location.pathname || '').split('?')[0].replace(/\/$/, '') || '/';
    var isCartPage =
      document.body.classList.contains('template-cart') || /\/cart$/.test(p) || p === 'cart';
    if (isCartPage) {
      window.location.reload();
    } else {
      refreshCartFromTheme();
    }
  }

  function runSyncMonogramWhenReady() {
    syncMonogramCount().then(function () {});
  }

  var syncMonogramTimeout = null;
  function scheduleSyncAfterQuantityChange(lineKey) {
    if (syncMonogramTimeout) clearTimeout(syncMonogramTimeout);
    syncMonogramTimeout = setTimeout(function () {
      syncMonogramTimeout = null;
      if (!lineKey) {
        runSyncMonogramWhenReady();
        return;
      }
      fetchCart().then(function (cart) {
        if (!cart || !cart.items) return;
        var item = cart.items.filter(function (i) {
          return i.key === lineKey;
        })[0];
        if (item && isMainMonogramItem(item)) runSyncMonogramWhenReady();
      });
    }, 1200);
  }

  /**
   * Run sync on page load and when drawer opens (always match counts).
   * Run sync on quantity change only when the changed line is a main monogram product; do nothing when non-monogram product is updated.
   */
  function initMonogramSync() {
    runSyncMonogramWhenReady();
    var drawer =
      document.getElementById('cart-drawer') || document.querySelector('[data-cart-drawer]');
    if (drawer) {
      var observer = new MutationObserver(function () {
        if (drawer.classList.contains('is-open')) runSyncMonogramWhenReady();
      });
      observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
    document.addEventListener('monoproductUpdatedInCart', function () {
      setTimeout(runSyncMonogramWhenReady, 600);
    });
    document.addEventListener('change', function (e) {
      var input =
        e.target &&
        e.target.getAttribute &&
        e.target.getAttribute('data-quantity-field') !== null &&
        e.target;
      if (
        !input ||
        !(e.target.closest && (e.target.closest('.cart__item') || e.target.closest('.cart-drawer')))
      )
        return;
      var lineKey =
        input.getAttribute('data-id') ||
        (input.id && input.id.indexOf('updates_') === 0 ? input.id.replace('updates_', '') : null);
      scheduleSyncAfterQuantityChange(lineKey || null);
    });
  }

  function bootMonogramAndRemoveButton() {
    initMonogramSync();
    initRemoveMonogramFromCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootMonogramAndRemoveButton);
  } else {
    bootMonogramAndRemoveButton();
  }

  /** ---------- Pre-checkout availability + monogram cleanup ---------- */
  function isMonogramAddonItem(item) {
    return item && item.variant_id === MONOGRAM_VARIANT_ID;
  }

  function getCheckoutUrl() {
    var root = (window.theme && window.theme.routes && window.theme.routes.root) || '/';
    if (root[root.length - 1] !== '/') root += '/';
    return root + 'checkout';
  }

  function getCartUpdateUrl() {
    var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart';
    return cartUrl.replace(/\/cart\/?$/, '/cart/update.js');
  }

  function findCartForm(triggerEl) {
    if (triggerEl && triggerEl.closest) {
      var fromTrigger = triggerEl.closest('.cart__form');
      if (fromTrigger) return fromTrigger;
    }
    return (
      document.querySelector('#cart-drawer .cart__form') ||
      document.querySelector('[data-cart-page] .cart__form') ||
      document.querySelector('.cart__form')
    );
  }

  function serializeCartForm(form) {
    var payload = {};
    if (!form) return payload;

    var noteEl = form.querySelector('textarea[name="note"]');
    if (noteEl) payload.note = noteEl.value;

    var attrInputs = form.querySelectorAll('[name^="attributes["]');
    if (attrInputs.length) {
      payload.attributes = {};
      attrInputs.forEach(function (el) {
        var match = el.name.match(/^attributes\[(.+)\]$/);
        if (match) payload.attributes[match[1]] = el.value;
      });
    }
    return payload;
  }

  function updateCartFromForm(form) {
    var payload = serializeCartForm(form);
    if (payload.note === undefined && !payload.attributes) {
      return Promise.resolve(null);
    }
    return fetch(getCartUpdateUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (r) {
        return r.json();
      })
      .catch(function () {
        return null;
      });
  }

  function goToCheckout(triggerEl) {
    return updateCartFromForm(findCartForm(triggerEl)).then(function () {
      window.location.href = getCheckoutUrl();
    });
  }

  function persistCartNoteField(el) {
    var payload = {};
    if (el.name === 'note') {
      payload.note = el.value;
    } else if (el.name && el.name.indexOf('attributes[') === 0) {
      var m = el.name.match(/^attributes\[(.+)\]$/);
      if (m) {
        payload.attributes = {};
        payload.attributes[m[1]] = el.value;
      }
    }
    if (payload.note === undefined && !payload.attributes) return;
    fetch(getCartUpdateUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
  }

  function initCartGiftNoteAutosave() {
    document.addEventListener(
      'change',
      function (e) {
        var el = e.target;
        if (!el || !el.matches) return;
        if (
          !el.matches(
            '[data-cart-gift-note], [data-cart-order-note], textarea[name="note"].cart__field'
          )
        )
          return;
        var form = el.closest('.cart__form');
        if (form) {
          updateCartFromForm(form);
        } else {
          persistCartNoteField(el);
        }
      },
      true
    );
  }

  function initCartGiftNoteAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('[data-cart-gift-note-add]');
      if (!btn) return;

      var widget = btn.closest('[data-gift-note-widget]');
      if (!widget) return;

      var textarea = widget.querySelector('[data-cart-gift-note]');
      var badge = widget.querySelector('[data-cart-gift-note-badge]');

      if (textarea) persistCartNoteField(textarea);

      widget.open = false;
      widget.removeAttribute('open');

      if (badge) {
        badge.hidden = !(textarea && textarea.value.trim());
      }
    });
  }

  function isVariantSellable(variant, totalQty) {
    if (!variant) return true;
    if (!variant.available) return false;
    if (
      variant.inventory_policy === 'deny' &&
      variant.inventory_management != null &&
      variant.inventory_quantity != null &&
      totalQty > variant.inventory_quantity
    ) {
      return false;
    }
    return true;
  }

  function fetchVariantMapForCart(items) {
    var seen = {};
    var idList = [];
    for (var i = 0; i < items.length; i++) {
      var vid = items[i].variant_id;
      if (!seen[vid]) {
        seen[vid] = true;
        idList.push(vid);
      }
    }
    return Promise.all(
      idList.map(function (vid) {
        return fetch('/variants/' + vid + '.js', { credentials: 'same-origin' })
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (variants) {
      var map = {};
      for (var j = 0; j < idList.length; j++) map[idList[j]] = variants[j];
      return map;
    });
  }

  function collectUnavailableLineKeys(cart, variantById) {
    var keys = {};
    var titles = [];
    function mark(item) {
      if (!item || keys[item.key]) return;
      keys[item.key] = true;
      var t = item.product_title || item.title || '';
      if (t && titles.indexOf(t) === -1) titles.push(t);
    }
    var items = cart.items || [];
    var qtyByVariant = {};
    for (var i = 0; i < items.length; i++) {
      var vid = items[i].variant_id;
      qtyByVariant[vid] =
        (qtyByVariant[vid] || 0) + (typeof items[i].quantity === 'number' ? items[i].quantity : 1);
    }
    var feeVariant = variantById[MONOGRAM_VARIANT_ID];
    var feeQty = qtyByVariant[MONOGRAM_VARIANT_ID] || 0;
    if (feeVariant && !isVariantSellable(feeVariant, feeQty)) {
      for (var j = 0; j < items.length; j++) {
        if (isMonogramAddonItem(items[j]) || isMainMonogramItem(items[j])) mark(items[j]);
      }
      return { keys: Object.keys(keys), titleList: titles };
    }
    var badVariants = {};
    for (var vidKey in qtyByVariant) {
      if (!Object.prototype.hasOwnProperty.call(qtyByVariant, vidKey)) continue;
      var vidNum = Number(vidKey);
      var v = variantById[vidNum] || variantById[vidKey];
      if (!v) continue;
      if (!isVariantSellable(v, qtyByVariant[vidKey])) badVariants[vidKey] = true;
    }
    for (var k = 0; k < items.length; k++) {
      var vk = items[k].variant_id;
      if (badVariants[vk] || badVariants[String(vk)]) mark(items[k]);
    }
    return { keys: Object.keys(keys), titleList: titles };
  }

  function removeCartLinesByKeys(keys) {
    if (!keys || !keys.length) return Promise.resolve(null);
    var updates = {};
    for (var i = 0; i < keys.length; i++) updates[keys[i]] = 0;
    var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart';
    var url = cartUrl.replace(/\/cart\/?$/, '/cart/update.js');
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates }),
    }).then(function (r) {
      return r.json();
    });
  }

  var checkoutValidationDialogEl = null;

  function openCheckoutBlockedDialog(titleList, onConfirmRemove, onDismiss) {
    if (checkoutValidationDialogEl && checkoutValidationDialogEl.open)
      checkoutValidationDialogEl.close();
    var dlg = document.createElement('dialog');
    dlg.className = 'checkout-validation-dialog';
    dlg.setAttribute('aria-labelledby', 'checkout-validation-heading');
    var listHtml = (titleList || [])
      .slice(0, 8)
      .map(function (t) {
        return '<li>' + String(t).replace(/</g, '&lt;') + '</li>';
      })
      .join('');
    if (titleList && titleList.length > 8) listHtml += '<li>…</li>';
    dlg.innerHTML =
      '<div class="checkout-validation-dialog__panel" role="document">' +
      '<div class="checkout-validation-dialog__body">' +
      '<h2 id="checkout-validation-heading" class="checkout-validation-dialog__heading">Some items in your cart are no longer available.</h2>' +
      '<p class="checkout-validation-dialog__intro">Remove unavailable items (including linked monogram add-ons where needed) to continue.</p>' +
      (listHtml ? '<ul class="checkout-validation-dialog__list">' + listHtml + '</ul>' : '') +
      '<div class="checkout-validation-dialog__actions">' +
      '<button type="button" class="btn btn--outline btn--primary" data-checkout-dismiss>Keep shopping</button>' +
      '<button type="button" class="btn btn--solid btn--tertiary" data-checkout-remove>Remove unavailable &amp; continue</button>' +
      '</div></div>' +
      '<div class="checkout-validation-dialog__busy" hidden aria-live="polite">' +
      '<span class="checkout-validation-dialog__spinner" aria-hidden="true"></span>' +
      '<p class="checkout-validation-dialog__busy-text">Updating your cart…</p>' +
      '</div></div>';
    document.body.appendChild(dlg);
    checkoutValidationDialogEl = dlg;
    var dismissBtn = dlg.querySelector('[data-checkout-dismiss]');
    var removeBtn = dlg.querySelector('[data-checkout-remove]');
    var busyEl = dlg.querySelector('.checkout-validation-dialog__busy');
    function setDialogBusy(on) {
      if (on) {
        dlg.classList.add('checkout-validation-dialog--busy');
        dlg.setAttribute('aria-busy', 'true');
        if (busyEl) {
          busyEl.hidden = false;
        }
        dismissBtn.disabled = true;
        removeBtn.disabled = true;
        removeBtn.setAttribute('aria-busy', 'true');
      } else {
        dlg.classList.remove('checkout-validation-dialog--busy');
        dlg.removeAttribute('aria-busy');
        if (busyEl) {
          busyEl.hidden = true;
        }
        dismissBtn.disabled = false;
        removeBtn.disabled = false;
        removeBtn.removeAttribute('aria-busy');
      }
    }
    function close() {
      try {
        dlg.close();
      } catch (e) {}
      dlg.remove();
      if (checkoutValidationDialogEl === dlg) checkoutValidationDialogEl = null;
    }
    dismissBtn.addEventListener('click', function () {
      close();
      if (onDismiss) onDismiss();
    });
    removeBtn.addEventListener('click', function () {
      setDialogBusy(true);
      var out = onConfirmRemove ? onConfirmRemove() : null;
      if (out && typeof out.then === 'function') {
        out.catch(function () {});
      } else {
        setDialogBusy(false);
        close();
      }
    });
    dlg.addEventListener('cancel', function (e) {
      if (dlg.classList.contains('checkout-validation-dialog--busy')) {
        e.preventDefault();
        return;
      }
      e.preventDefault();
      close();
      if (onDismiss) onDismiss();
    });
    if (typeof dlg.showModal === 'function') dlg.showModal();
    else if (onConfirmRemove) onConfirmRemove();
  }

  var checkoutValidationRunning = false;
  function runCheckoutValidation(triggerEl) {
    if (checkoutValidationRunning) return;
    checkoutValidationRunning = true;
    function restoreTrigger() {
      checkoutValidationRunning = false;
      if (triggerEl) {
        triggerEl.removeAttribute('aria-busy');
        triggerEl.style.pointerEvents = '';
      }
    }
    if (triggerEl) {
      triggerEl.setAttribute('aria-busy', 'true');
      triggerEl.style.pointerEvents = 'none';
    }
    fetchCart()
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) {
          restoreTrigger();
          goToCheckout(triggerEl);
          return null;
        }
        return fetchVariantMapForCart(cart.items).then(function (variantById) {
          return { cart: cart, variantById: variantById };
        });
      })
      .then(function (data) {
        if (!data) return;
        var result = collectUnavailableLineKeys(data.cart, data.variantById);
        if (!result.keys.length) {
          restoreTrigger();
          goToCheckout(triggerEl);
          return;
        }
        restoreTrigger();
        openCheckoutBlockedDialog(result.titleList, function () {
          return removeCartLinesByKeys(result.keys)
            .then(function () {
              return syncMonogramCount({ skipAfterCartSync: true });
            })
            .then(function () {
              goToCheckout(triggerEl);
            })
            .catch(function () {
              window.location.reload();
            });
        });
      })
      .catch(function () {
        restoreTrigger();
        goToCheckout(triggerEl);
      });
  }

  function initCheckoutValidation() {
    document.addEventListener(
      'click',
      function (e) {
        var anchor =
          e.target && e.target.closest && e.target.closest('a.cart__checkout[href*="checkout"]');
        var btn =
          e.target &&
          e.target.closest &&
          e.target.closest('button.cart__checkout[name="checkout"]');
        var el = anchor || btn;
        if (!el) return;
        e.preventDefault();
        e.stopPropagation();
        runCheckoutValidation(el);
      },
      true
    );
    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || !form.classList || !form.classList.contains('cart__form')) return;
        var sub = e.submitter || form.querySelector('button[name="checkout"].cart__checkout');
        if (!sub || sub.name !== 'checkout' || !sub.classList.contains('cart__checkout')) return;
        e.preventDefault();
        e.stopPropagation();
        runCheckoutValidation(sub);
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCheckoutValidation();
      initCartGiftNoteAutosave();
      initCartGiftNoteAdd();
    });
  } else {
    initCheckoutValidation();
    initCartGiftNoteAutosave();
    initCartGiftNoteAdd();
  }

  // Baby List Integration - Update button when variant changes
  function updateBabylistButton(variantId) {
    var babylistButton = document.getElementById('AddToBabylist');
    if (!babylistButton) return;

    // Try to get product JSON from the page
    var productJson = document.querySelector('[data-product-json]');
    var product = productJson ? JSON.parse(productJson.innerHTML) : null;

    if (!product || !product.variants) return;

    // Find the selected variant
    var variant = product.variants.find(function (v) {
      return v.id == variantId;
    });
    if (!variant) return;
    var data = {
      images: variant.featured_image ? variant.featured_image.src : product.featured_image,
      price: (variant.price / 100).toFixed(2),
      title: product.title + ' - ' + variant.title,
      url: window.location.origin + +window.location.pathname + '?variant=' + variant.id,
    };

    babylistButton.setAttribute(
      'href',
      'javascript: bl.addToRegistry(' + JSON.stringify(data) + ')'
    );
  }

  function checkVariantChange() {
    var variantIdInput = document.querySelector('[data-form-wrapper] input[name="id"]');
    if (variantIdInput) {
      variantIdInput.addEventListener('change', () => {
        updateBabylistButton(variantIdInput.value);
      });
    }
  }
  document.addEventListener('DOMContentLoaded', function () {
    checkVariantChange();
  });

  var INVENTORY_QTY_WORDS = [
    'ONE',
    'TWO',
    'THREE',
    'FOUR',
    'FIVE',
    'SIX',
    'SEVEN',
    'EIGHT',
    'NINE',
    'TEN',
    'ELEVEN',
    'TWELVE',
    'THIRTEEN',
    'FOURTEEN',
    'FIFTEEN',
    'SIXTEEN',
    'SEVENTEEN',
    'EIGHTEEN',
    'NINETEEN',
    'TWENTY',
    'TWENTY ONE',
    'TWENTY TWO',
    'TWENTY THREE',
    'TWENTY FOUR',
    'TWENTY FIVE',
    'TWENTY SIX',
    'TWENTY SEVEN',
    'TWENTY EIGHT',
    'TWENTY NINE',
    'THIRTY',
    'THIRTY ONE',
    'THIRTY TWO',
    'THIRTY THREE',
    'THIRTY FOUR',
    'THIRTY FIVE',
    'THIRTY SIX',
    'THIRTY SEVEN',
    'THIRTY EIGHT',
    'THIRTY NINE',
    'FORTY',
    'FORTY ONE',
    'FORTY TWO',
    'FORTY THREE',
    'FORTY FOUR',
    'FORTY FIVE',
    'FORTY SIX',
    'FORTY SEVEN',
    'FORTY EIGHT',
    'FORTY NINE',
    'FIFTY',
  ];

  function inventoryQtyToWord(qty) {
    var index = qty - 1;
    if (index >= 0 && index < INVENTORY_QTY_WORDS.length) {
      return INVENTORY_QTY_WORDS[index];
    }
    return String(qty);
  }

  function convertInventoryCountEl(countEl) {
    if (!countEl) return;
    var qty = parseInt(countEl.textContent, 10);
    if (!isNaN(qty) && qty > 0) {
      countEl.textContent = inventoryQtyToWord(qty);
    }
  }

  function convertInventoryCounts(root) {
    (root || document).querySelectorAll('[data-remaining-count]').forEach(convertInventoryCountEl);
  }

  // theme.dev.js runs first and overwrites Liquid words with numbers before this script loads.
  convertInventoryCounts();

  document.addEventListener('theme:variant:change', function (e) {
    convertInventoryCountEl(e.target.querySelector('[data-remaining-count]'));
  });
})();
